
import React, {FC} from 'react';
import {Footer} from 'components/ContentPagesComponents/VoiceAgent/Footer';
import {Handlers, State} from 'components/ContentPagesComponents/VoiceAgent/reducer';
import {ReportIframe} from 'components/ContentPagesComponents/VoiceAgent/Report';
import {VoiceControl} from 'components/ContentPagesComponents/VoiceAgent/VoiceControl';
import {ReportModal} from 'components/ReportModal';

import * as styles from './styles.module.scss';

type ContentProps = {
	state: State
	handlers: Handlers
}

export const Content: FC<ContentProps> = ({state, handlers}) => (
	<>
		<div className={styles.content}>
			<div className={styles.filler}>
				<span>
					Your voice call remains connected until
					you close the tab or end the call.
				</span>
				<div>
					<span>You can ask ...</span>
					<ul>
						<li>Give me quick overview</li>
						<li>Are my numbers good?</li>
						<li>What do I do next?</li>
					</ul>
				</div>
				<span>
					Speak naturally!
					Specific questions help us provide better answers.
				</span>
			</div>
			<div className={styles.report}>
				<ReportIframe cache={state.report} />
			</div>
			<VoiceControl
				onClose={handlers.toggleOpen}
				onReport={handlers.onReport}
			/>
		</div>
		<Footer
			report={state.report}
			handlers={handlers}
		/>
		{state.overlay && (
			<ReportModal
				cache={state.report}
				onHide={handlers.toggleOverlay}
				voice={false}
			/>
		)}
	</>
);
